import Handlebars from "handlebars";
import { formatDate, parseDate } from "./index.js";

Handlebars.registerHelper(
    "prop",
    function (
        this: unknown,
        obj: Record<string, unknown> | undefined,
        key: unknown,
        options: Handlebars.HelperOptions,
    ): string {
        if (obj !== undefined && (typeof key === "string" || typeof key === "number" || typeof key === "boolean")) {
            const data = Handlebars.createFrame(options.data);
            data.value = obj[String(key)];
            return options.fn(this, { data });
        }
        return options.inverse(this);
    },
);

Handlebars.registerHelper("json", function (this: unknown, obj: unknown) {
    return new Handlebars.SafeString(obj !== undefined ? JSON.stringify(obj) : "");
});

Handlebars.registerHelper(
    "regex",
    function (this: unknown, value: unknown, regex: string, options: Handlebars.HelperOptions) {
        const match = new RegExp(regex).exec(String(value));
        if (match) {
            const data = Handlebars.createFrame(options.data);
            data.match = match;
            return options.fn(this, { data });
        }
        return options.inverse(this);
    },
);

Handlebars.registerHelper("formatDate", function (this: unknown, value: unknown, format: string, fromFormat: unknown) {
    const date = (function () {
        if (value instanceof Date) {
            return value;
        }

        if (typeof value === "number") {
            return value;
        }

        if (typeof value === "string") {
            if (typeof fromFormat !== "string") {
                return value;
            }

            if (fromFormat === "ms") {
                const numeric = Number(value);
                return Number.isNaN(numeric) ? null : numeric;
            }

            return parseDate(value, fromFormat, new Date());
        }
        return null;
    })();

    return date !== null ? formatDate(date, format) : "";
});

Handlebars.registerHelper("typeof", function (this: unknown, value: unknown, typeOrOptions: unknown) {
    if (typeof typeOrOptions === "string") {
        return typeof value === typeOrOptions;
    }
    return typeof value;
});

export function render<Context>(template: string, ctx?: Context) {
    return Handlebars.compile(template, { noEscape: true, preventIndent: true })(ctx);
}

export function renderJson<Context>(template: string, ctx?: Context) {
    return JSON.parse(render(template, ctx));
}

export function renderedObject(obj: object, ctx: object | undefined) {
    return Object.entries(obj).reduce(
        (acc, [key, value]) => {
            acc[render(key, ctx)] = render(value, ctx);
            return acc;
        },
        {} as Record<string, string>,
    );
}
